import { WasmSharedTypedArray } from "./Misc/wasmSharedTypedArray";
import { WasmTypedArray } from "./Misc/wasmTypedArray";
const WasmInstanceMap = new WeakMap();
/**
 * Load MMD WASM instance
 *
 * Wasm instance type is determined by the argument instanceType
 *
 * For example, if you want to use most stable MMD WASM instance, pass MmdWasmDebugInstanceType to instanceType
 * @param instanceType MMD WASM instance type
 * @param threadCount Thread count for WASM threading (default: navigator.hardwareConcurrency). threadCount must be greater than 0
 * @returns MMD WASM instance
 */
export async function GetMmdWasmInstance(instanceType, threadCount = navigator.hardwareConcurrency) {
    const wasmBindgen = instanceType.getWasmInstanceInner();
    {
        const instance = WasmInstanceMap.get(wasmBindgen);
        if (instance !== undefined)
            return instance;
    }
    let resolvePromise = null;
    WasmInstanceMap.set(wasmBindgen, new Promise(resolve => resolvePromise = resolve));
    const mmdWasmInstance = { ...wasmBindgen };
    const initOutput = await mmdWasmInstance.default();
    mmdWasmInstance.init();
    const memory = initOutput.memory;
    function createTypedArray(typedArrayConstructor, byteOffset, length) {
        return new WasmTypedArray(typedArrayConstructor, memory, byteOffset, length);
    }
    function createSharedTypedArray(typedArrayConstructor, byteOffset, length) {
        return new WasmSharedTypedArray(typedArrayConstructor, memory, byteOffset, length);
    }
    mmdWasmInstance.memory = memory;
    if (memory.buffer instanceof ArrayBuffer) {
        mmdWasmInstance.createTypedArray = createTypedArray;
    }
    else {
        mmdWasmInstance.createTypedArray = createSharedTypedArray;
    }
    await mmdWasmInstance.initThreadPool?.(threadCount);
    resolvePromise(mmdWasmInstance);
    return mmdWasmInstance;
}
